const enGB = {
  navigation: {
    mydevice: "Il mio dispositivo",
    mymobile: "My mobile"
  },
  photoorganiser: {
    navigation: {
      photos: "Foto",
      favorites: "Preferiti",
      collections: "Collezioni",
      events: "Eventi",
      latestuploads: "Ultimi caricamenti"
    },
    empty(source) {
      return " " + source
    }
  },
  mymobile: {
    title: "Get your phone photos in an instant!",
    qrcode: {
      title: "Scan the QR code",
      subtitle: "(No need to install App)"
    },
    instruction: {
      title: "Let's get started!",
      step_1: "Open your camera app",
      step_2: "Scan the QR code",
      step_3: "Follow the instruction on your mobile"
    }
  },
  layout: {
    flex: "Flessibile",
    square: "Quadrato"
  },
  calender: {
    allmonths: "Tutti i mesi",
    allyears: "Tutti gli anni",
    months: {
      january: "Gennaio",
      february: "Febbraio",
      march: "Marzo",
      april: "Aprile",
      may: "Maggio",
      june: "Giugno",
      july: "Luglio",
      august: "Agosto",
      september: "Settembre",
      october: "Ottobre",
      november: "Novembre",
      december: "Dicembre"
    }
  },
  generic: {
    sortBy: "Ordina per",
    selected: "Foto selezionate",
    done: "Aggiungi foto",
    back: "Indietro",
    images: "Foto",
    selection: "Selezione",
    date: "Data",
    name: "Nome",
    az: "Nome file A-Z",
    za: "Nome file Z-A",
    newestfirst: "Data scatto nuovo-vecchio",
    oldestfirst: "Data scatto vecchio-nuovo",
    photos: "Foto",
    all: "Tutte",
    yes: "Sì",
    no: "no",
    nodate: "Nessuna data"
  },
  rangeText: {
    minMax(min, max) {
      return "Devi selezionare tra " + min + " e " + max + " foto"
    },
    min(min) {
      return "Ti ci vorranno almeno " + min + " ore per creare il tuo fotolibro."
    },
    max(max) {
      return "Devi selezionare al massimo " + max + " foto"
    }
  },
  addMorePhotos: "Aggiungi altre foto",
  upload: {
    browseButton: "Aggiungi foto",
    uploadlimit(maxSize) {
      return "Le foto devonno essere inferiori a " + maxSize + " nel formato file"
    },
    dragImage: "o trascina e rilascia le foto qui.",
    errors: {
      GENERIC_ERROR: "Qualcosa non ha funzionato. Riprova più tardi o contatta il nostro servizio clienti.",
      EMPTY_FILE: "Riferimento immagine perso. Aggiungi di nuovo l'immagine",
      MAX_FILE_SIZE: "Il file deve essere più piccolo di {0} mb",
      UNSUPPORTED_FILE_TYPE: "Formato di file non supportato",
      MAX_IMAGE_RESOLUTION: "Il file deve essere più piccolo di {0} pixel",
      INVALID_IMAGE: "Il file è corrotto"
    },
    errorSummary(number) {
      return "Non è stato possibile caricare " + number + " file"
    },
    errorDialog: {
      headline: "Attenzione!",
      ingress: "Impossibile caricare i file seguenti:",
      filenameColumn: "File",
      reasonColumn: "Ragione"
    },
    uploaded: "Caricato",
    estimating: "Tempo stimato",
    estimatedleft: "Tempo residuo stimato",
    ok: "OK",
    cancel: "Annulla",
    details: "Dettagli"
  }
}

export default enGB
